import { RootState } from "../store";

export const selectDocuments = (state: RootState) => state.document;
